import { render, staticRenderFns } from "./day.vue?vue&type=template&id=8bc39246&scoped=true&"
import script from "./day.vue?vue&type=script&lang=js&"
export * from "./day.vue?vue&type=script&lang=js&"
import style0 from "./day.vue?vue&type=style&index=0&id=8bc39246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc39246",
  null
  
)

export default component.exports